export default "__VITE_ASSET__4332b7ab__"